// Map subject color tag to tailwind classes
export const SUBJECT_COLORS = {
  primary: { bg: "bg-[#D4C4FB] dark:bg-[#B794F4]", chip: "bg-[#D4C4FB]" },
  mint:    { bg: "bg-[#9DFFB0] dark:bg-[#68D391]", chip: "bg-[#9DFFB0]" },
  yellow:  { bg: "bg-[#FFE066] dark:bg-[#F6E05E]", chip: "bg-[#FFE066]" },
  peach:   { bg: "bg-[#FFB38E] dark:bg-[#F6AD55]", chip: "bg-[#FFB38E]" },
  blue:    { bg: "bg-[#90E0FF] dark:bg-[#63B3ED]", chip: "bg-[#90E0FF]" },
};

export const SUBJECT_ICONS = [
  "BookOpen", "Atom", "Calculator", "FlaskConical", "Globe",
  "Languages", "Music", "Palette", "Cpu", "Leaf", "Brain", "Heart",
];
